import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContactsService } from '../../../store/services/contacts.service';
import { Button, ButtonColor, ButtonSize } from '../../../store/models/button.model';

export enum EUploadState {
  SELECT_TEMPLATE,
  UPLOADING,
  PREVIEW,
  COMPLETE,
}

export enum EUploadTemplate {
  V1 = 'v1',
  V2 = 'v2',
}

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss'],
})
export class UploadDialogComponent implements OnInit {
  state: EUploadState = EUploadState.SELECT_TEMPLATE;

  states = EUploadState;
  templates = EUploadTemplate;

  inputForm: FormGroup;

  downloadTemplateByEmailButton: Button = {
    size: ButtonSize.NORMAL,
    color: ButtonColor.ORANGE,
    text: 'Download template',
    onClick: () => this.downloadTemplate('move_contacts_by_email'),
  };

  downloadTemplateByIdButton: Button = {
    size: ButtonSize.NORMAL,
    color: ButtonColor.ORANGE,
    text: 'Download template',
    onClick: () => this.downloadTemplate('move_contacts_by_id'),
  };

  constructor(
    private readonly contactsService: ContactsService,
  ) {
  }

  ngOnInit(): void {
    if (this.state === EUploadState.SELECT_TEMPLATE) {
      this.inputForm.addControl(
        'template',
        new FormControl(EUploadTemplate.V2, [Validators.required]),
      );
    }
  }

  downloadTemplate(templateName: string): void {
    this.contactsService.downloadMoveContactsTemplate(templateName)
      .subscribe((res) => {
        const url = window.URL.createObjectURL(res);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${templateName}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }, error => {
      });
  }
}
